/**
 * 对 Reporter 的简单封装
 * 在 App 环境下, 会使用 Jsbridge 进行上报, 替代默认的 web 上报.
 */

import ReporterClass from '@tencent/nb-h5-reporter';
import { curEnv, ENV_ENUM } from '@tencent/nb-h5-tools/env';
import JsBridge from '@/utils/jsBridge/index';

let customReport = null;
// 实际的上报点
if (curEnv === ENV_ENUM.APP_ANDROID || curEnv === ENV_ENUM.APP_IOS) {
  // APP 环境内, 优先走 JsBridge 上报
  // 将参数封装成 Jsbridge 要求的格式
  customReport = (eventName, reportParams) => JsBridge.Ares.report({
    event: eventName || '',
    params: reportParams || {},
  });
}

const Reporter = new ReporterClass({
  report: customReport,
});

export default Reporter;
